import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@material-ui/core';

// Confirmación de reenvío de correo al alumno. El correo se envía al destinatario
// de student.email; no requiere datos adicionales (operationData vacío en el POST).
const ResendEmail = ({ student, loading, onConfirm, disabled }) => {
    const handleConfirm = () => {
        onConfirm(student);
    };

    return (
        <Box>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                Se reenviará el correo al alumno <strong>{student.first_name} {student.last_name}</strong> a la
                dirección <strong>{student.email}</strong>.
            </Typography>
            <Box mt={3}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConfirm}
                    disabled={disabled || loading}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    {loading ? 'Enviando...' : 'Enviar Correo'}
                </Button>
            </Box>
        </Box>
    );
};

export default ResendEmail;
